import Sticker from "./Sticker";

export default class RoundSticker extends Sticker {
    constructor(props) {
        super();
        this.preview_scale_factor = props.hasOwnProperty('preview_scale_factor') ? props.preview_scale_factor : 1.59;
        this.props = {
            font_family: props.font_family,
            background: props.background,
            text_color: props.text_color,
            image: props.image,
            model: props.model,
            first_name: props.first_name,
            last_name: props.last_name,
            image_border: props.image_border,
            data_only: props.data_only,
        }
        this.data = {
            sizes: {
                width: this.convertToPixels(30) * this.preview_scale_factor,
                height: this.convertToPixels(30) * this.preview_scale_factor,
            },
            mm_sizes: {
                width: 30,
                height: 30
            },
            text_coordinates: {
                single: {
                    x: this.convertToPixels(15) * this.preview_scale_factor,
                    y: this.convertToPixels(12.2) * this.preview_scale_factor
                },
                multiple: [
                    {
                        x: this.convertToPixels(15) * this.preview_scale_factor,
                        y: this.convertToPixels(12.2) * this.preview_scale_factor
                    },
                    {
                        x: this.convertToPixels(15) * this.preview_scale_factor,
                        y: this.convertToPixels(12.2) * this.preview_scale_factor
                    }
                ]
            },
            text_sizes: {
                width: this.convertToPixels(22) * this.preview_scale_factor,
                height: this.convertToPixels(13) * this.preview_scale_factor
            },
            image_coordinates: {
                x: this.convertToPixels(15) * this.preview_scale_factor,
                y: this.convertToPixels(24) * this.preview_scale_factor
            },
            image_sizes: {
                width: this.convertToPixels(8) * this.preview_scale_factor,
                height: this.convertToPixels(8) * this.preview_scale_factor
            },
            font_size: this.convertToPixels(6.5) * this.preview_scale_factor,
            font_weight: 400,
            text_uppercase: false,
            full_name: this.getFullName()
        }
    }
}
